import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class StorageService {
  public storeData(key: string, value: any): void {
    localStorage.setItem(key, value);
  }

  // TODO: Why does this service exist? Also return type is not correct here, https://developer.mozilla.org/en-US/docs/Web/API/Storage/getItem return type can only be null or string
  public getData(
    key: string
  ): string | number | boolean | null | undefined | void {
    return localStorage.getItem(key);
  }
}
